import { Component, OnInit } from '@angular/core';
import {RegistrationService} from "../../services/registration-service";

@Component({
  selector: 'pla-about-us-page',
  templateUrl: './about-us-page.component.html',
  styleUrls: ['./about-us-page.component.scss']
})
export class AboutUsPageComponent implements OnInit {

  public plateCount: number = 0;
  constructor(private registrationService: RegistrationService) {
    this.registrationService
      .getPlateCount()
      .subscribe((_: { totalCount: number }) => {
        this.plateCount = _.totalCount;
      });
  }

  ngOnInit(): void {
  }

}
